










































import { Component, Prop, Watch } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import RuleSettings from './rule-settings.vue';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';
import { mixins } from 'vue-class-component';
const md5 = require('md5');

@Component({
  components: {
    FormOverlay,
    DialogForm,
    RuleSettings,
  }
})
export default class AddBotDetectionRules extends mixins(FlowMixin,Form) {
  @Prop({ default: {} })
  data: any;

  target: any;
  show: boolean = false;
  loading: boolean = false;
  isLoadingDictionary: boolean = false;
  active_name: string = '';
  active_id: string = '';
  needToUpdateRuleName=false;
  active_rule: any = {
    conditions: {}
  };
  relation: string = 'and';

  ruleIndex: number = -1;

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.active_rule));
  }

  get self() {
    return this;
  }

  @Watch('relation')
  onRelationChanged(val: string) {
    this.active_rule.logicalRelation = val;
  }

  save() {
    if (this.isLoadingDictionary) return

    if(this.ruleIndex === -1) {
      this.active_rule.name = this.getDefaultRuleName;
      this.target.form.flowInline.rules.push(this.active_rule);
    } else {
      if(this.needToUpdateRuleName || this.data?.rule?.name === '') {
        this.active_rule.name = this.getDefaultRuleName;
      }
      this.$set(this.target.form.flowInline.rules, this.ruleIndex, this.active_rule)
    }

    this.loading = false;
    this.close()
  }

  get getDefaultRuleName() {
    const { conditions } = this.active_rule;
    const item = { conditions };
    if(item) {
      return this.generate_name(item, false).map(item=>item.name).join(' | ').substring(0, 80)
    }

    return '';
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
  }

  onSaveDictionary(isLoading) {
    this.isLoadingDictionary = isLoading
  }

  mounted() {
    this.bus.on('loading-add-dictionary', this.onSaveDictionary);

    this.relation = 'and';

    const { rule, target } = this.data
    this.target = target

    if (!rule) {
      this.ruleIndex = -1;
      this.active_rule = {
        conditions: {},
        name: '',
        status: 'active',
        default: false,
        logicalRelation: 'and',
        paths: [
          {
            name: 'Path 1',
            weight: 100,
            status: 'active',
            redirectMode: '302',
            redirectDomain: '',
            directLinking: false,
            landings: [],
            offers: []
          }
        ]
      };
      this.oldHash = this.getCurrentHash();
    } else {
      // для того чтоб перерисовывались dictionary - isp при переткрытии
      this.ruleIndex = -1;
      this.active_rule = {conditions: {}};
      this.$nextTick(() => {
        this.ruleIndex = this.target.form.flowInline.rules.indexOf(rule);
        this.active_rule = JSON.parse(JSON.stringify(rule)); //cloneDeep doesn't work
        this.oldHash = this.getCurrentHash();
        this.relation = this.active_rule.logicalRelation || 'and';
        this.needToUpdateRuleName = this.data.rule.name === this.getDefaultRuleName
      });
    }

    this.show = true;
  }

  beforeDestroy() {
    this.bus.off('loading-add-dictionary', this.onSaveDictionary);
  }
}
